import { Aurelia, Container, autoinject } from 'aurelia-framework';

import { BaseService } from 'Common/BaseService';
import { Config } from 'Config';
import { HttpClient } from 'aurelia-http-client';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { RESTApiAdapter } from '../Adapters/RESTApiAdapter';

export class LoggerService extends BaseService {

    protected static instance: LoggerService;

    constructor(restApiAdapter: RESTApiAdapter) {
        super(restApiAdapter);
    }

    static get Instance() {

        // Chech is isntance null or undefined
        if (ObjectHelper.IsNullOrUndefined(this.instance)) {

            // create instance of SystemService
            this.instance = new LoggerService(new Aurelia().container.get(RESTApiAdapter));
        }

        // return instance
        return this.instance;
    }

    public Custom(message: string, level?: string) { 
        this.Log((level ? level : 'Custom'), message);
    }

    public Info(message: string) {
        this.Log('Info', message);
    }

    public Success(message: string) {
        this.Log('Success', message);
    }

    public Warning(message: string) {
        this.Log('Warning', message);
    }

    public Error(message: string) {
        this.Log('Error', message);
    }

    public Critical(message: string) {
        this.Log('Critical', message);
    }

    private Log(level: string, message: string) {
        let request = {
            "timeStamp": new Date(),
            "logger": "Aurelia.Client.Logger",
            "level": level,
            "message": message
        }

        let body = {};
        body['CreateParam'] = {
            "EntityName": "Log",
            "Data": request
        }

        this.restApiAdapter.Execute(body);
    }
}